module.exports = __webpack_public_path__ + "img/lightbox_btn_01.6e24e589.jpg";